<template>
  <div class="top-content-base">
    <v-layout justify-center>
      <div class="relative">
        <div
          class="lp-top-title"
          :class="{
            'top-title-padding': !strongTitle,
            'top-title-bg': titleFontBig,
          }"
        >
          <span>{{ title }}</span>
        </div>
      </div>
    </v-layout>

    <slot name="subTitle" />
  </div>
</template>

<script>
export default {
  props: {
    strongTitle: { type: String, default: () => '' },
    title: { type: String, default: () => '' },
    titleFontBig: { type: String, default: () => '' },
  },
};
</script>

<style scoped>
.lp-top-title {
  font-size: 30px;
  color: #625d53;
  font-weight: bold;
  white-space: pre-wrap;
  line-height: 1.1em;
}
.lp-top-title::before {
  content: '';
  position: absolute;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 10px;
  border-radius: 5px;
  left: -28px;
  right: -28px;
  bottom: -18px;
}
.no-webp .lp-top-title::before {
  background-image: url('/img/programs/fellowship/mayo/lpFrmFondiLine1.png');
}
.webp .lp-top-title::before {
  background-image: url('/img/programs/fellowship/mayo/lpFrmFondiLine1.webp');
}
.lp-top-title.top-title-bg {
  font-size: 3em;
  line-height: 1.2em;
}
@media (max-width: 1400px) {
  .lp-top-title {
    font-size: 20px;
  }
  .lp-top-title.top-title-bg {
    font-size: 24px;
  }
  .lp-top-title::before {
    height: 8px;
    bottom: -12px;
  }
}
@media (max-width: 1023px) {
  .lp-top-title {
    font-size: 15px;
  }
  .lp-top-title.top-title-bg {
    font-size: 19px;
  }
  .lp-top-title::before {
    height: 6px;
    bottom: -10px;
  }
  .lp-top-title::after {
    width: 40px;
    height: 47px;
    right: -50px;
  }
}
@media (max-width: 767px) {
  .lp-top-title.top-title-bg {
    line-height: 1.2em;
  }
  .lp-top-title.top-title-padding {
    padding-top: 10px;
  }
  .lp-top-title::before {
    height: 5px;
    bottom: -10px;
    left: 0px;
    right: 0px;
  }
  .lp-top-title::after {
    display: none;
    width: 26px;
    height: 22px;
    right: 0px;
  }
}
@media (max-width: 360px) {
  .lp-top-title {
    font-size: 12px;
  }
  .lp-top-title.top-title-bg {
    font-size: 14px;
  }
}
</style>
